<d-card>
  <img src="https://ciam-cdnendpoint.azureedge.net/testasset01/login.png" alt="" />
  <ng-container *ngIf="login_hint && step === 'PasswordCallback'">
    <p id="user">{{ login_hint }}</p>
    <h3 id="passwordMessage">Enter Password</h3>
  </ng-container>
  <div
    *ngIf="
      step ===
      'TextOutputCallback-TextOutputCallback-HiddenValueCallback-ConfirmationCallback'
    "
    class="qrMessage"
  >
    <h3>One time authentication</h3>
    <p>
      Since this is your first time setting up the Microsoft Authenticator, scan
      the QR code below with Microsoft authenticator app to verify your device
      for logging in.
    </p>
    <p>
      You will need Microsoft Authenticator application on your mobile device in
      order to proceed further.
    </p>
  </div>
  <div *ngIf="step === 'NameCallback-ConfirmationCallback'" class="otpMessage">
    <h3>One time authentication</h3>
    <p class="message">
      Type in the 6 digit authentication code from your Microsoft authenticator
      app.
    </p>
    <p class="strong">Enter code below.</p>
  </div>
  <div id="otp-container" *ngIf="step === 'NameCallback-ConfirmationCallback'">
    <input *ngFor="let digit of otp; let i = index" #otpBox class="otp-box" type="text" maxlength="1" inputmode="numeric" (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)" />
    
  </div>
  
  <div id="widget-root"></div>
  <div
    *ngIf="
      login_hint &&
      step ===
        'TextOutputCallback-TextOutputCallback-HiddenValueCallback-ConfirmationCallback'
    "
    class="qrMessage"
  >
    <p>Don’t have access to the app? Try another way</p>
  </div>
</d-card>

<div class="controls">
    <button (click)="changeAccount()">Change account</button>
    <!-- <d-button (click)="showMFA()">show mfa</d-button><br>
    <d-button (click)="logout()">Logout</d-button><br>
    <d-button (click)="test()">Get user Info</d-button><br>
    <d-button (click)="tokens()">Get tokens</d-button> -->
</div>
